module.exports = __webpack_public_path__ + "media/images/NHC_pc_logo-13ab30067d762b6d7f39803601a27044.png";